import { MergedProps } from '../../close-account-v3/combined-closure'

type negativeCloseAccountFields = {
  screen: string
  screen_name: string
  object_name: string
  current_subscription: string
}

type pendingInvestmentsAccountFields = {
  screen: string
  screen_name: string
  object_name: string
  current_subscription: string
}

type eligibilityStatus = {
  eligible: boolean
  status: string
  recurringOn?: boolean
  account?: string
  tier?: string
}

export const PlusUpgradeTapped = {
  object_name: 'myAccountsPlusUpgrade',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  cta_title: 'Upgrade to this plan',
}

export const PremiumUpgradeTapped = {
  object_name: 'myAccountsPremiumUpgrade',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  cta_title: 'Upgrade to this plan',
}

export const CloseLaterTapped = {
  object_name: 'myAccountsCloseLaterAccount',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  cta_title: 'Close Later Account',
}

export const CloseSpendTapped = {
  object_name: 'myAccountsCloseSpendAccount',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  cta_title: 'Close Spend Account',
}

export const CancelSubscriptionTapped = {
  object_name: 'myAccountsCancelSubscription',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  cta_title: 'Cancel Subscription',
}

export const NegativeBalancePageViewedFields = (
  product: eligibilityStatus['tier'],
): negativeCloseAccountFields => ({
  ...NegativeBalancePageViewedFields,
  object_name: 'myAccountsNegativeBalance',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  current_subscription: `${product}`,
})

export const NegativeBalanceContactSupport = {
  object_name: 'myAccountsNegativeBalanceContactSupportButton',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  cta_title: 'Contact support',
}

export const PendingInvestmentsPageViewedFields = (
  product: eligibilityStatus['tier'],
): pendingInvestmentsAccountFields => ({
  ...NegativeBalancePageViewedFields,
  object_name: 'myAccountsPendingInvestments',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  current_subscription: `${product}`,
})

export const PendingInvestmentsTurnOffRecurring = {
  object_name: 'myAccountPendingInvestments',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  cta_title: 'Cancel recurring transfers ',
}

export const PendingInvestmentsViewHistory = {
  object_name: 'myAccountPendingInvestments',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  cta_title: 'View history',
}

export const NoLinkedAccount = {
  object_name: 'myAccountLinkFundingSource',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
}

export const NoLinkedAccountButtonTapped = {
  object_name: 'myAccountLinkFundingSource',
  screen: 'myAccounts',
  screen_name: 'myAccounts',
}

type ScreenFields = {
  screen: string
  screen_name: string
}

const screenFields = (screen: string): ScreenFields => ({
  screen,
  screen_name: screen,
})

const MY_ACCOUNTS = 'myAccounts'

const myAccountsScreenFields = screenFields(MY_ACCOUNTS)

export const myAccountsScreenViewedFields = () => ({
  ...myAccountsScreenFields,
  object_name: MY_ACCOUNTS,
})

export const myAccountsCloseButtonTappedFields = () => ({
  ...myAccountsScreenFields,
  object_name: 'myAccountsClose',
  cta_title: 'Close My Account',
})

enum SubscriptionType {
  core = 'core',
  later = 'later',
  spend = 'spend',
}

export const currentSubscriptionType = (props: MergedProps) => {
  if (props.hasSpendAccount) {
    return SubscriptionType.spend
  } else if (props.hasLaterAccount) {
    return SubscriptionType.later
  } else {
    return SubscriptionType.core
  }
}

type myAccountsModalProps = {
  modalName: string
  currentSubscription: string
}

type myAccountsModalFields = {
  screen: string
  screen_name: string
  object_name: string
  current_subscription: string
}

export const myAccountsModalViewedFields = ({
  modalName,
  currentSubscription,
}: myAccountsModalProps): myAccountsModalFields => ({
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  object_name: `myAccounts${modalName}Modal`,
  current_subscription: currentSubscription,
})

export const myAccountsModalCancelledFields = ({
  modalName,
  currentSubscription,
}: myAccountsModalProps): myAccountsModalFields => ({
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  object_name: `myAccounts${modalName}ModalCancel`,
  current_subscription: currentSubscription,
})

export const myAccountsModalConfirmedFields = ({
  modalName,
  currentSubscription,
}: myAccountsModalProps): myAccountsModalFields => ({
  screen: 'myAccounts',
  screen_name: 'myAccounts',
  object_name: `myAccounts${modalName}ModalConfirm`,
  current_subscription: currentSubscription,
})

const REQUEST_CLOSE_ACCOUNT = 'requestCloseAccount'

const requestCloseAccountScreen = screenFields(REQUEST_CLOSE_ACCOUNT)

export const requestCloseAccountScreenViewedFields = () => ({
  ...requestCloseAccountScreen,
  object_name: REQUEST_CLOSE_ACCOUNT,
})

const CLOSE_ACCOUNT_CONFIRMATION = 'requestCloseAccountConfirmation'

const requestCloseAccountConfirmationFields = screenFields(
  CLOSE_ACCOUNT_CONFIRMATION,
)

type FormValues = {
  reason: string
  comments: string
}

type requestCloseAccountFields = {
  screen: string
  screen_name: string
  object_name: string
  cta_title: string
  reason: string
  body: string
}

export const requestCloseAccountCancelledFields = (
  values: FormValues,
): requestCloseAccountFields => ({
  ...requestCloseAccountConfirmationFields,
  object_name: `${CLOSE_ACCOUNT_CONFIRMATION}ConfirmModalCancel`,
  cta_title: 'X (close modal)',
  reason: values.reason,
  body: values.comments,
})

export const requestCloseAccountConfirmedFields = (
  values: FormValues,
): requestCloseAccountFields => ({
  ...requestCloseAccountConfirmationFields,
  object_name: `${CLOSE_ACCOUNT_CONFIRMATION}ConfirmModalConfirm`,
  cta_title: 'Close',
  reason: values.reason,
  body: values.comments,
})
